import React, {useRef, useEffect} from "react";
import {Init} from "./components/init";
import {isEmpty} from "@helpers/helpers";

let map = null;
let mapTimeout = undefined;

function Marker({center, zoom, type, options = null, onChange, zoom_control = true, tapFullscreen = false, polygonLocations = null, showMarker = true}) {

    let Ref = useRef(null);

    useEffect(() => {
        const $color = "#160647";
        let marker = null;

        if (!isEmpty(mapTimeout)) {
            clearTimeout(mapTimeout)
        }

        if (!isEmpty(map)) {
            /*map.off();
            map.remove()*/
        }

        mapTimeout = setTimeout(() => {

            if (!isEmpty(Ref.current)) {
                map = Init(Ref.current, center, zoom, zoom_control, type, tapFullscreen, polygonLocations, options);

                const MarkerIcon = L.icon({
                    iconUrl: "/_img/icons/pin-main.svg",
                    iconAnchor: [center[0] - 15, center[1] + 10],
                });

                if (onChange !== undefined) {
                    map.on("click", function (e) {
                        if (null != marker) {
                            marker.remove();
                        }

                        marker = L.marker([e.latlng.lat, e.latlng.lng], {
                            autoPan: true,
                            color: $color,
                            icon: MarkerIcon,
                        }).addTo(map);
                        onChange([e.latlng.lat, e.latlng.lng]);
                    });
                }

                if (!isEmpty(center) && center[0] && center[1] && showMarker) {
                    marker = L.marker([center[0], center[1]], {
                        autoPan: true,
                        color: $color,
                        icon: MarkerIcon,
                    }).addTo(map);
                }

                if (
                    process.browser &&
                    typeof type !== "undefined" &&
                    type === "neshan"
                ) {
                    const map_element = document.querySelector(".maps");
                    const element = map_element.querySelector(
                        'a[href="https://maps.neshan.org"]'
                    );
                    if (element) {
                        element.parentNode.style.zIndex = "440";
                    }
                }
            }
        }, 600);
    });

    return <div ref={Ref} className="maps rounded-8"/>;
}

export default React.memo(Marker);
